// Generated by scripts/build-ui-icons.mjs.
export { HandCoins as default } from "../ui/glyphs-4";
